import type { MessageKeys } from 'next-intl';
import type { RecaptionPrompt } from '@/app/types';

/**
 * 创建默认的 RecaptionPrompt 对象
 */
export const getDefaultRecaptionPrompt = (
  t: (key: MessageKeys<IntlMessages, 'style.animation' | 'motionLevel.middle'>) => string,
): RecaptionPrompt => {
  return {
    subject: [],
    environment: [],
    style: [t('style.animation')],
    motionLevel: [t('motionLevel.middle')],
  };
};
